module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('nav', {
    staticClass: "navbar navbar-fixed-top"
  }, [_vm._c('div', {
    staticClass: "container-fluid xs-p-0"
  }, [_vm._c('div', {
    staticClass: "navbar-logo"
  }, [_vm._c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": "/"
    }
  }, [_vm._c('img', {
    attrs: {
      "src": "/static/img/logo.png"
    }
  })])], 1), _vm._v(" "), _vm._c('div', {
    staticClass: "right-navbar"
  }, [(_vm.currentUser.loggedIn) ? _vm._c('LoggedInLinks') : _vm._c('LoggedOutLinks')], 1), _vm._v(" "), (_vm.page.publicNav) ? _vm._c('div', {
    staticClass: "public-nav"
  }, [_vm._c('div', {
    staticClass: "dropdown"
  }, [_vm._m(0), _vm._v(" "), _vm._c('ul', {
    staticClass: "dropdown-menu nav",
    attrs: {
      "role": "menu"
    }
  }, [_vm._l((_vm.navLinks), function(link) {
    return _vm._c('li', [_vm._c('router-link', {
      attrs: {
        "to": {
          name: link.routeName
        }
      }
    }, [_vm._v(_vm._s(link.title))])], 1)
  }), _vm._v(" "), _vm._c('li', [(!_vm.currentUser.loggedIn) ? _vm._c('LoggedOutLinks') : _vm._e()], 1)], 2)])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-expanded": "false"
    }
  }, [_vm._c('div', {
    staticClass: "bar1"
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "bar2"
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "bar3"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4aa608f4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/Navbar.vue
// module id = 661
// module chunks = 1